import addMinutes from "date-fns/addMinutes";

import { ChangesData, FacilityCourses } from "./constants";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const isFormChanged = (changesState: ChangesData): boolean => {
  return Object.keys(changesState).some(
    course =>
      changesState[course].isTrackConditionChanged ||
      changesState[course].isNoteChanged
  );
};

export const getDateBeforeMinutes = (minutes: number): string => {
  const now = new Date();

  const formatUTC = dateObject => {
    const year = dateObject.getUTCFullYear();
    const month = dateObject.getUTCMonth();
    const date = dateObject.getUTCDate();
    const hours = dateObject.getUTCHours();
    const minutes = dateObject.getUTCMinutes();
    const seconds = dateObject.getUTCSeconds();

    return `${year}-${month + 1 < 10 ? `0${month + 1}` : month + 1}-${
      date < 10 ? `0${date}` : date
    } ${hours < 10 ? `0${hours}` : hours}:${
      minutes < 10 ? `0${minutes}` : minutes
    }:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return formatUTC(addMinutes(now, -minutes));
};

export const getSurfaceType = (surface: racehorse360.CourseSurface): string => {
  let surfaceType = "";

  if (
    [
      racehorse360.CourseSurface.COURSE_SURFACE_ALL_WEATHER_TRACK,
      racehorse360.CourseSurface.COURSE_SURFACE_ALL_WEATHER_TRAINING
    ].includes(surface)
  ) {
    surfaceType = "synthetic";
  }

  if (
    [
      racehorse360.CourseSurface.COURSE_SURFACE_TURF,
      racehorse360.CourseSurface.COURSE_SURFACE_STEEPLECHASE,
      racehorse360.CourseSurface.COURSE_SURFACE_OUTER_TURF,
      racehorse360.CourseSurface.COURSE_SURFACE_HUNT_ON_TURF,
      racehorse360.CourseSurface.COURSE_SURFACE_TIMBER,
      racehorse360.CourseSurface.COURSE_SURFACE_TURF_TRAINING,
      racehorse360.CourseSurface.COURSE_SURFACE_JUMP,
      racehorse360.CourseSurface.COURSE_SURFACE_HUNT,
      racehorse360.CourseSurface.COURSE_SURFACE_DOWNHILL_TURF,
      racehorse360.CourseSurface.COURSE_SURFACE_INNER_TURF,
      racehorse360.CourseSurface.COURSE_SURFACE_HURDLE
    ].includes(surface)
  ) {
    surfaceType = "turf";
  }

  if (
    [
      racehorse360.CourseSurface.COURSE_SURFACE_INNER_TRACK,
      racehorse360.CourseSurface.COURSE_SURFACE_DIRT,
      racehorse360.CourseSurface.COURSE_SURFACE_DIRT_TRAINING
    ].includes(surface)
  ) {
    surfaceType = "dirt";
  }

  return surfaceType;
};

export const getRelatedFacilities = (
  response: racehorse360.IListCoursesResponse
): FacilityCourses => {
  const relatedFacilities = {};

  response.courses.forEach(course => {
    const facilityId = course.facility.id;

    if (relatedFacilities[facilityId]) {
      relatedFacilities[facilityId].courses = [
        ...relatedFacilities[facilityId].courses,
        course
      ];
    } else {
      relatedFacilities[facilityId] = {
        facility: course.facility,
        courses: [course]
      };
    }
  });

  return relatedFacilities;
};

export const getCoursesModelData = (
  response: racehorse360.IListCoursesResponse
): any => {
  const originalCourses = {};
  const workingCourses = {};
  const newChangesState = {};

  response.courses.forEach(course => {
    originalCourses[course.id] = course;

    const newObject = racehorse360.Course.create(course);

    if (!Object.prototype.hasOwnProperty.call(newObject, "comment")) {
      newObject.comment = "";
    }
    if (!Object.prototype.hasOwnProperty.call(newObject, "trackCondition")) {
      newObject.trackCondition = null;
    }

    workingCourses[newObject.id] = newObject;

    newChangesState[newObject.id] = {
      isNoteChanged: false,
      isTrackConditionChanged: false
    };
  });

  return { workingCourses, originalCourses, newChangesState };
};
